export default {
  general: {
    Start: "Start",
    Back: "Powrót",
    Next: "Dalej",
    Cancel: "Anuluj",
    Skip: "Pomiń",
    Preview: "Podgląd",
    Email: "Wprowadź swój email",
    EmailHint: "Email",
    Phone: "Wprowadź numer telefonu",
    PhoneHint: "Numer telefonu",
    Password: "Wprowadź swoje hasło",
    PasswordHint: "Hasło",
    PasswordReenter: "Wprowadź ponownie swoje hasło",
    CreatePasswordTitle: "Utwórz hasło, aby zabezpieczyć swoje konto i zapewnić bezpieczny dostęp.",
    CreatePasswordCheck: "Hasło powinno mieć co najmniej {1}8 znaków{2}, zawierać {3}małe{4} i {5}duże{6} litery, {7}cyfrę{8} oraz {9}znak specjalny{10}.",
    CreatePasswordMustMatch: "Hasło musi się zgadzać.",
    CreateNewPassword: "Utwórz nowe hasło",
    Create: "Utwórz",
    Setup: "Ustaw",
    RememberMe: "Zapamiętaj mnie",
    ForgotPassword: "Zapomniałeś hasła?",
    Login: "Zaloguj",
    Logout: "Wyloguj",
    CloseAccount: "Zamknij konto",    
    CloseAccountAsk: "Czy na prawdę chcesz zamknąć konto?",
    Yes: "Tak",
    No: "Noe",
    or: "lub",
    Add: "Dodaj",
    DontHaveAccount: "Nie masz konta?",
    Register: "Zarejestruj się",
    Verify: "Weryfikuj",
    Send: "Wyślij",
    TryAgain: "Spróbuj ponownie",
    EnterName: "Wprowadź swoje imię",
    EnterNameHint: "Imię",
    EnterSurname: "Wprowadź swoje nazwisko",
    EnterSurnameHint: "Nazwisko",
    Connecting: "Łączenie...",
    Search: "Szukaj",
    Generate: "Generuj",
    Finish: "Zakończ",
    Save: "Zapisz",
    SaveInProgres: "Zapisywanie w trakcie..."
  },

  bottomPanel: {
    Profile: "Profil",
    Tasks: "Zadania",
    Host: "Gospodarz",
    Messages: "Wiadomości",
    Alerts: "Powiadomienia"
  },
  
  login: {
    VerificationTitleEmail: "Wprowadź kod weryfikacyjny wysłany na Twój email.",
    VerificationTitlePhone: "Wprowadź kod weryfikacyjny wysłany na Twój telefon.",
    HaventReceivedCode: "Nie otrzymałeś emaila?",
    CodeSendPhone: "Kod weryfikacyjny został wysłany na Twój telefon.",
    CodeSendEmail: "Kod weryfikacyjny został wysłany na Twój email.",
    CodeSendFailed: "Nie mona wysłać kodu weryfikacyjnego.",
    CodeSendDisabled: "Proszę poczekać {1} sek,, zanim będzie można ponownie zażądać kodu weryfikacyjnego.",
    CodeWrong: "Zły kod, spróbuj ponownie.",
    EnterFullName: "Proszę wprowadzić pełne imię i nazwisko, aby ukończyć swój profil.",
    AgreeTo: "Zgadzam się na",
    TermsConditions: "Warunki i zasady",
    PasswordResetTitle: "Proszę podać adres e-mail, na który zostanie wysłany link do resetowania hasła.",
    PosswordResetSend: "Na wskazany adres email została wysłana istrukcja do resetu hasła.",
    PasswordResetNew: "Nowe hasło zostało ustawione.",
    CantCreateAccount: "Nie można utworzyć konta. Spróbuj ponownie później.",
    CantLogin: "Nie można się zalogować, błędne dane logowania.",
    LoginDeactivated: "Nie można się zalogować, Twoje konto jest zamknięte. Skontaktuj się z pomocą techniczną, aby ponownie otworzyć konto.",
    PropertiesTitle: "Nieruchomości",
    PropertiesDescription: "Szybki, wygodny i przejrzysty sposób na zaprezentowanie swojej nieruchomości i przyciągnięcie odpowiednich klientów.",
    GuestsTitle: "Goście",
    GuestsDescription: "Twoja kompletna baza danych gości, dzięki której masz pod ręką poprzednie kontakty. Łatwo nawiąż kontakt i zaproś ich ponownie, mając całą historię komunikacji i aktywności w jednym miejscu.",
    OffersTitle: "Oferty",
    OffersDesctiption: "Bądź na bieżąco ze wszystkimi wysłanymi ofertami wynajmu, otrzymuj automatyczne przypomnienia, aby nic nie zostało pominięte, i kieruj swoją ofertą w stronę udanej rezerwacji.",
    ReservationsTitle: "Rezerwacje",
    ReservationsDescription: "Przejrzysty i intuicyjny sposób zarządzania rezerwacjami. Dokładnie wiedz, kiedy odwiedzają Cię goście, z przypomnieniami o zadaniach, aby zapewnić obsługę na najwyższym poziomie.",
    MarketingTitle: "Marketing",
    MarketingDescription: "Wydajne narzędzie do tworzenia angażujących treści marketingowych na Facebooku i Instagramie, oparte na sztucznej inteligencji.",
    FinanceTitle: "Finanse",
    FinanceDescription: "Prosty, przyjazny dla użytkownika przegląd finansów Twojej nieruchomości, obejmujący zwrot z inwestycji i płatności klientów — wszystko w jednym miejscu.",
    StatisticsTitle: "Statystyki",
    StatisticsDescription: "Szybki przegląd najważniejszych wskaźników dotyczących nieruchomości, który pomoże Ci śledzić wyniki, a dzięki sztucznej inteligencji otrzymasz sugestie na czym należy się skupić w następnej kolejności."
  },

  termsConditions: {
    title: "Warunki i zasady",
    introduction: "Witamy na naszej stronie! Korzystając z naszych usług, zgadzasz się przestrzegać poniższych Warunków i Zasad.",
    useOfWebsite: "Zgadzasz się korzystać z tej strony tylko w celach zgodnych z prawem. Nie możesz używać tej strony w sposób, który mógłby uszkodzić, wyłączyć lub utrudnić funkcjonowanie strony.",
    accountRegistration: "Jeśli tworzysz konto na naszej stronie, jesteś odpowiedzialny za zachowanie poufności swoich danych logowania oraz za wszystkie działania, które mają miejsce pod Twoim kontem.",
    intellectualProperty: "Wszystkie treści na tej stronie, w tym teksty, grafiki i logo, są własnością właściciela strony i są chronione prawem autorskim.",
    privacyPolicy: "Twoja prywatność jest dla nas ważna. Proszę zapoznać się z naszą Polityką Prywatności, aby dowiedzieć się, jak przetwarzamy Twoje dane osobowe.",
    limitationOfLiability: "Nie ponosimy odpowiedzialności za jakiekolwiek szkody lub straty wynikłe z korzystania z tej strony. Korzystasz ze strony na własne ryzyko.",
    modifications: "Zastrzegamy sobie prawo do modyfikowania tych Warunków i Zasad w dowolnym czasie. Zmiany będą publikowane na tej stronie, a Twoją odpowiedzialnością jest okresowe sprawdzanie tych zmian.",
    governingLaw: "Te Warunki i Zasady podlegają prawu jurysdykcji, w której znajduje się właściciel strony. Wszelkie spory będą rozstrzygane w odpowiednich sądach tej jurysdykcji.",
    contactUs: "Jeśli masz jakiekolwiek pytania lub wątpliwości dotyczące tych Warunków i Zasad, skontaktuj się z nami."
  },

  host: {
    Properties: "Nieruchomości",
    PropertyDescribe: "Opisz nieruchomość",
    Guests: "Goście",
    GuestAdd: "Dodaj gościa",
    Places: "Miejsca",
    PlaceDescribe: "Opisz miejsce",
    PlaceAI: "Podaj szczegóły miejsca, które chcesz dodać, aby wygenerować je automatycznie.",
    Attractions: "Atrakcje",
    AttractionDescribe: "Opisz atrakcję",
    AttractionAI: "Podaj szczegóły atrakcji, którą chcesz dodać, aby wygenerować ją automatycznie.",
    Dishes: "Dania",
    DisheDescribe: "Opisz danie",
    Restaurants: "Restauracje",
    RestaurantDescribe: "Opisz restaurację",
    Offers: "Oferty",
    OfferAdd: "Dodaj ofertę",
    Reservations: "Rezerwacje",
    ReservationAdd: "Dodaj rezerwację",
    Marketing: "Marketing",
    Statistics: "Statystyki",
    Finance: "Finanse",
    Calendar: "Kalendarz",
    Overview: "Podgląd",
    Gallery: "Galeria",
    AttractionOverview: "Przegląd atrakcji”",
    PlaceOverview: "Przegląd miejsca",
    DishOverview: "Przegląd dania",
    RestaurantOverview: "Przegląd restauracji",
    AddFailed: "Wystąpił błąd podczas dodawania.",
    UpdateFailed: "Wystąpił błąd podczas zapisu.",
    AddOk: "Dodano poprawnie.",
    UpdateOk: "Zapisano poprawnie.",
    UniqueIdExists: "Unikalne ID zostało już użyte, wybierz inne.",
    ListEmpty: "Lista jest pusta, dodaj pierwszy element.",
    ListCantLoadItem: "Nie można załadować elementu!",
    ListCancelAsk: "Czy na pewno chcesz stracić naniesione zmiany?",
    DeleteItemAsk: "Czy na pewno chcesz usunąć ten element?",
    DeleteItemOk: "Usunięto element.",
    DeleteItemFailed: "Nie można usunąć elementu!"
  },

  edit: {
    Name: "Nazwa",
    NameHint: "Wprowadź nazwę",
    Slogan: "Slogan",
    SloganHint: "Wprowadź slogan",
    PhotoAdd: "Dodaj zdjęcia",
    PhotoSelect: "Galeria jest pusta",
    PhotoChangeOrder: "Przytrzymaj i przesuń zdjęcia, aby uporządkować kolejność. Pierwsze zdjęcie będzie miniaturką.",
    Description: "Opis",
    DescriptionAdd: "Dodaj opis",
    AttractionsAdd: "Dodaj atrakcje",
    RestaurantsAdd: "Dodaj restauracje",
    FactsAdd: "Dodaj ciekawe fakty",
    DetailsAdd: "Dodaj szczegóły",
    DishesAdd: "Dodaj dania",
    VisitTime: "Czas wizyty",
    VisitTimeHint: "Wprowadź czas wizyty",
    TicketsBuy: "Gdzie kupić bilety",
    TicketsBuyHint: "Wprowadź miejsce zakupu biletów",
    Website: "Strona internetowa",
    WebsiteHint: "Wprowadź stronę internetową",
    Place: "Miejsce",
    PlaceHint: "Wybierz miejsce",
    Address: "Adres",
    AddressHint: "Wprowadź adres",
    MoreInformations: "Więcej informacji",
    MoreInformationsHint: "Wprowadź więcej informacji",
    UniqueId: "Unikalny ID",
    UniqueIdHint: "Wprowadź unikalny ID (a-z 0-9 _)"
  },

  language: {
    Polish: "Polski",
    English: "Angielski",
    German: "Niemiecki",
    Spanish: "Hiszpański",
    AITranslate: "Tłumaczenie AI"
  },

  ai: {
    translationNotAvailable: "Tłumaczenie AI jest obecnie niedostępne.",
    serviceNotAvailable: "Usługa AI jest niedostępna."
  },

  addressPopup: {
    copyAddress: "📋 Kopiuj adres",
    copyGPS: "📍 Kopiuj współrzędne GPS",
    openMaps: "🗺 Otwórz w mapach"
  },

  state: {
    placeNew: "Nowy",
    placeInPreparation: "W przygotowaniu",
    placePublished: "Opublikowany"
  },

  waitingList: {
    Sign: "Zapisz się",
    AlreadyExists: "Jesteś już zapisany na liscie oczekujących.",
    Added: "Zostałeś dodany do listy oczekujących, dziękujemy za zainteresowanie naszą aplikacją!",
    Title: "Zapisz się na listę oczekujących",
    Agreement: "Zapisując się wyrażasz zgodę na otrzymywanie na podany adres Email informacji o aplikacji Flatlinker. Możesz zrezygnować z otrzymywanych informacji pisząc na adres newsletter@flatlinker.com z treścią mejla: Wypisz mnie z listy."
  }
};